<template>
        <div id='zzupload'>
              <NavTop title='资质-图片上传'/>
              <div class="title-row">请上传资质图片</div>
              <div class="imgrow">
                 <div class="imgcol">
                  <van-uploader :after-read="afterRead" :upload-icon="img1==''?undefined:img1" :preview-image='false' image-fit="cover" name='img_1'/>
                  <span>图片1</span>
                 </div>
                 <div class="imgcol">
                  <van-uploader :after-read="afterRead" :upload-icon="img2==''?undefined:img2" :preview-image='false' image-fit="cover" name='img_2'/>
                  <span>图片2</span>
                 </div>
                 <div class="imgcol">
                  <van-uploader :after-read="afterRead" :upload-icon="img3==''?undefined:img3" :preview-image='false' image-fit="cover" name='img_3'/>
                  <span>图片3</span>
                 </div>
              </div>
              <div class="btnrow">
                  <div class="sumitbtn" @click="doUpload">
                     确认上传图片
                  </div>
              </div>
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
import { NoticeBar, Uploader} from 'vant'
export default {
  data(){
      return{
         img1:'',
         img2:'',
         img3:'',
         uploadinfo:{},
         hasuploaded:false,
         processing:false
      }
  },  
  name: 'zzupload',
  created(){
     this.getList()
  },
  methods:{
     getList(){
        this.$post("/user/getCertification").then((data)=>{
               if(data.result.success){
                  this.hasuploaded=parseInt(data.result.info.hasuploaded)
                  if(this.hasuploaded){
                     this.uploadinfo=data.result.info.uploadinfo
                     this.img1=this.uploadinfo.img1
                     this.img2=this.uploadinfo.img2!=''?this.uploadinfo.img2:''
                     this.img3=this.uploadinfo.img3!=''?this.uploadinfo.img3:''
                  }
               }else{
                 this.$toast(data.result.info)
                 setTimeout(()=>{this.$go("/my")},1000)
               }
           }) 
     },
     doUpload(){
        if(this.processing){
           this.$toast("请等待提交完成");return false;
        }
        if(this.img1==''||this.img1==undefined){
            this.$toast("请至少上传一张图片");return false;
        }
        
        this.uploadinfo["img1"]=this.img1
        this.uploadinfo["img2"]=this.img2
        this.uploadinfo["img3"]=this.img3
 
        this.processing=true
        this.$post("/user/saveCertification",{uploadinfo:this.uploadinfo}).then((data)=>{
           this.processing=false
           if(data.result.success){
              this.$toast(data.result.info)
              this.getList()
           }else{
              this.$toast(data.result.info)
           }
        })
     },
     afterRead(file,info) { 
      let name=info.name   
      let tag=name.split("_")
      let index=tag[1]
      const uploadImgFile=file.content
      this.$post("/uploader/headImgBase64",{type:'headimg',image:uploadImgFile}).then((data)=>{
           if(data.result.success){
               this['img'+index]=data.result.info.url 
           }
      })
    }
  },
  components:{
      NavTop,
      [NoticeBar.name]:NoticeBar,
      [Uploader.name]:Uploader
  }
}
</script>
<style scoped>
#mltb_upload{background-color:#fff;min-height: 100vh;padding-bottom: 0.5rem;}
.content{font-size:0.5rem;overflow-x:hidden;word-break:break-all;text-align: left;width:100%;position: relative;}
.sqimg{width:100%;display: block;}
::v-deep .fixcon{margin-bottom: 0!important;}
.title-row{font-size:0.3rem;width: 100%;text-align: left;font-weight: 600;padding: 0.3rem;}
.imgrow{display: flex;flex-flow: row;width: 100%;padding: 0 0.3rem;}
.imgcol{width:25%;display: flex;flex-flow: column nowrap;justify-content: center;font-size:0.25rem;}

.btnrow{display: flex;flex-flow: row;width: 100%;justify-content: center;align-items: center;padding: 0 0.3rem;margin-top: 0.25rem;}
.sumitbtn{width:100%;border-radius: 0.2rem;background-color: #ee0a24;color:#fff;font-size:0.38rem;height:1rem;display: flex;flex-flow: row nowrap;align-items: center;justify-content: center;}

::v-deep .van-uploader{display:flex ;justify-content: center;}
::v-deep .van-uploader__upload-icon{font-size:80px;}
::v-deep .van-uploader__upload{margin: 0;background-color: #fff;}

.inputout{margin-top:10px;width:100%;}
.inputclass{border: 1px solid #ccc;padding: 0 0.3rem;font-size:0.3rem;width:100%;height:1rem;line-height: 1rem;}
.msg{position: absolute;top:0;left:0;width:100%;height:1rem;display: flex;flex-flow: row nowrap;align-items: center;background-color: #fef0f0;opacity: .7;padding-left: 0.125rem;}
.msgtxt{font-size:0.32rem;color:#f56c6c;font-weight: 600;}
</style>


